/* istanbul ignore file */
import { MultiSelectInputFilter, ConditionProps } from 'framework/list';
import React from 'react';
import VacancyInput from 'domain/recruiting/candidate/shared/input/VacancyInput';

const SearchVacancyFilter = ({ label, ...props }: Omit<ConditionProps, 'children'> & { label: string }) => {
  return (
    <MultiSelectInputFilter {...props}>
      <VacancyInput {...props} label={label} />
    </MultiSelectInputFilter>
  );
};

export default SearchVacancyFilter;
